<template>
    <div style="max-width: 150px; text-align: center">
        <v-speed-dial        
            v-model="fab"            
            bottom
            direction="bottom"
            open-on-hover
        >    
            <template #activator>    
                <v-progress-circular
                    v-if="indeterminate"
                    loading
                    indeterminate
                    :color="state.color"
                    size="50"
                >
                    <v-btn 
                        fab
                        small
                        depressed
                        :color="state.color"                
                    >
                        <v-icon 
                            :color="state.iconColor" 
                            v-html="fab ? 'mdi-close' : state.icon" 
                        />
                    </v-btn>
                </v-progress-circular>        
                <v-btn 
                    v-else
                    fab            
                    depressed
                    :color="state.color"                
                >
                    <v-icon 
                        :color="state.iconColor" 
                        v-html="fab ? 'mdi-close' : state.icon" 
                    />
                </v-btn>
            </template>
            <v-btn
                v-if="isStoppable"
                fab
                dark
                small
                color="red"
                class="white-text"
                @click="stop"
            >
                <v-icon>mdi-stop</v-icon>
            </v-btn>
            <v-btn
                v-else
                fab
                dark
                small
                color="green"
                class="white-text"
                @click="start"
            >
                <v-icon>mdi-play</v-icon>
            </v-btn>   
        </v-speed-dial>
        <v-subheader 
            v-if="info"
            :class="indeterminate ? 'mt-n5' : 'mt-n6'"
        >
            {{ appState }}
        </v-subheader>        
    </div>
</template>
<script>
    import { mapActions, mapState } from 'pinia'
    import { useAppStore } from '@/store/app-store'
    export default {
        name: 'AppState',
        props: {
            universe: String,
            app: String,
            info: Boolean,
        },
        data: () => ({
            tick: null,
            appState: '',
            fab: false,
        }),        
        computed: {
            ...mapState(useAppStore, ['allApps']),
            isStoppable () {
                return ['Deploying', 'Running'].includes(this.appState)
            },
            appData () {
                return {
                    app: this.app,
                    universe: this.universe,
                }
            },
            indeterminate () {                
                return this.appState === 'Deploying' 
            },
            state () {
                if (this.appState === 'Failed') {
                    return {
                        color: 'red',
                        icon: '$vuetify.icons.appFailed',
                        iconColor: 'white',
                    }
                }
                if (this.appState === 'Deploying') {
                    return {
                        color: 'teal',
                        icon: 'mdi-rocket-launch-outline',
                        iconColor: 'white',
                    }
                }                
                if (this.appState === 'Running') {
                    return {
                        color: 'green',
                        icon: 'mdi-rocket-launch',
                        iconColor: 'white',
                    }
                }

                return {
                    color: 'grey lieghten-4',
                    icon: 'mdi-rocket-outline',
                    iconColor: 'black',
                }
            },
        },
        watch: {
            allApps (v) {
                const appData = v[`${this.universe}-${this.app}`] || {}
                this.appState = appData.state || ''
            },            
        },
        async mounted () {              
            const appData = this.allApps[`${this.universe}-${this.app}`] || {}
            this.appState = appData.state || ''   
        },        
        unmounted () {
            clearInterval(this.tick)
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeDestroy () {
            clearInterval(this.tick)
        },
        deactivated () {
            clearInterval(this.tick)
        },
        methods: {
            ...mapActions(useAppStore, ['loadAllApps', 'loadAppState', 'startApp', 'stopApp']),
            async start () {
                this.loading = true
                await this.startApp(this.universe, this.app)
                await this.loadAllApps()
                this.loading = false
            },
            async stop () {
                this.loading = true
                await this.stopApp(this.universe, this.app)
                await this.loadAllApps()
                this.loading = false
            },
        },        
    }
</script>
